<template>
  <div class="ac-card-content">
    <div class="ac-header-container">
      <div class="flex-row align-center">
        <button
          class="ac-close-button margin-right-4"
          @click="toggleActionModal(true, 'new-comfort-credits')"
        >
          <img
            src="@shared/assets/img/general/x-black.png"
            alt="x"
            class="ac-close"
          >
        </button>
        <div
          class="ac-header"
        >
          Edit Rewards
        </div>
      </div>
    </div>
    <div class="ac-body-container">
      <div class="sac__font-14 med mb-2">
        The reason for the award will be seen by the customer in the Homeowner App. Do you want to continue?
      </div>
      <div
        class="ac-input-container"
      >
        <div class="sac__font-14 med margin-bottom-4">
          Reason given to homeowner
        </div>
        <SACInput
          v-if="transaction.rewardType === 'voucher'"
          field="newReason"
          placeholder="Enter Reason"
          :value="newReason"
          :change="change"
          :error="errorObj.reasonErr"
        />
        <div
          v-else
          class="sac__font-14"
        >
          "{{ transaction.reason }}"
        </div>
      </div>
    </div>
    <div class="ac-footer-container">
      <button
        class="ac-form-cancel-button"
        @click="goBack"
      >
        Cancel
      </button>
      <button
        class="ac-form-button"
        @click="saveAndContinue"
      >
        Save
      </button>
    </div>
  </div>
</template>
<script>
import SACInput from '@shared/components/sac/SACInput.vue';
import comfortCreditsMixin from '@shared/mixins/comfortCreditsMixin';

export default {
  name: 'ComfirmTransactionReason',
  components: {
    SACInput,
  },
  mixins: [comfortCreditsMixin],
  props: {
    close: Function,
    goBack: Function,
  },
  data() {
    return {
      newReason: '',
      errorObj: '',
    };
  },
  methods: {
    change(f, v) {
      this[f] = v;
    },
    async saveAndContinue() {
      await this.$store.dispatch('postComfortCredits');
      this.close();
    },
  },
};
</script>
